export const logoHeader = process.env.REACT_APP_LOGO_HEADER;
export const loginBackground = process.env.REACT_APP_LOGIN_BG;
export const exportHeader = process.env.REACT_APP_EXPORT_HEADER;
export const ukpcLogo = process.env.REACT_APP_UKPC_LOGO;
export const intelliparkLogo = process.env.REACT_APP_INTELLIPARK_LOGO;

